
// 赛题专区 产品赛道 报名参加
const COMPETITION_PRODUCTION_JOIN_URL = 'https://www.heywhale.com/u/813445'
// 赛题专区 数字赛道 报名参加
const COMPETITION_DIGITA_JOIN_URL = 'https://www.heywhale.com/u/d759cc'
// 登陆
const LOGIN_URL = 'https://www.heywhale.com/u/f5e54d'

const QUESTION_PRODUCTION_JOIN_URL = 'https://www.heywhale.com/u/6c37a0'

const QUESTION_DIGITA_JOIN_URL = 'https://www.heywhale.com/u/1f93f3'

const HOME_URL = 'https://www.heywhale.com/u/f6183e'

const USER_DETAIL = 'https://www.heywhale.com/home/user/profile/'


const NEWS = {
  '2019': [
    {
      title: '2019平安产险数字科技冠军赛正式启动',
      src: 'https://mp.weixin.qq.com/s/Wjct6cLElp_akLrMNoQEVg',
    },{
      title: '2019平安产险数字科技冠军赛 | 复赛名单公布',
      src: 'https://mp.weixin.qq.com/s/8RJMes3O3PDO9UiDax4imQ',
    },{
      title: '数字科技冠军赛 | 五城首战告捷，赛区最强战队诞生',
      src: 'https://mp.weixin.qq.com/s/3CivGhH1Yqloo-Xt_C2KjA',
    },{
      title: '决赛将至 | 区域十强战队上线，你Pick哪一队？',
      src: 'https://mp.weixin.qq.com/s/HO1Zc5XiWuLrv2z9qiAjmQ',
    },{
      title: '决赛回顾 | 终极角逐功成名遂，数字科技冠军赛圆满落幕',
      src: 'https://mp.weixin.qq.com/s/WOoLhu6SCDlX9DOQWiX_mA',
    },{
      title: '冠军专访 | 王牌高光时刻，未来可期',
      src: 'https://mp.weixin.qq.com/s/R2nTmybQByfKSKiH1ntPmQ',
    }
  ],
  '2020': [
    {
      title: '2020中国大学生保险数字科技挑战赛全面升维启动',
      src: 'https://mp.weixin.qq.com/s/BfW5VrMyRKLiT58yCRYR6g'
    },{
      title: '挑战赛 | 必须细品的赛题秘籍，三大赛道金牌导师在线“著书教学”',
      src: 'https://mp.weixin.qq.com/s/BfW5VrMyRKLiT58yCRYR6g'
    },{
      title: '复赛名单揭晓 | 五城高燃复赛即刻打响！',
      src: 'https://mp.weixin.qq.com/s/dXGzGOQUAdquXIU91btunQ'
    },{
      title: '复赛精彩回顾 | 全国复赛五城齐发，群英集结体验升级!',
      src: 'https://mp.weixin.qq.com/s/UsL7k0xiwFkVEkC4MprsTw'
    }
  ]
}

export {
  COMPETITION_PRODUCTION_JOIN_URL,
  COMPETITION_DIGITA_JOIN_URL,
  NEWS,
  LOGIN_URL,
  QUESTION_PRODUCTION_JOIN_URL,
  QUESTION_DIGITA_JOIN_URL,
  HOME_URL,
  USER_DETAIL
}